var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.inputType === 'text' ? _c('v-text-field', {
    attrs: {
      "label": _vm.label,
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.localValue,
      callback: function callback($$v) {
        _vm.localValue = $$v;
      },
      expression: "localValue"
    }
  }) : _vm.inputType === 'number' ? _c('v-text-field', {
    attrs: {
      "label": _vm.label,
      "type": "number",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.localValue,
      callback: function callback($$v) {
        _vm.localValue = _vm._n($$v);
      },
      expression: "localValue"
    }
  }) : _vm.inputType === 'select' ? _c('v-select', {
    attrs: {
      "items": _vm.options,
      "label": _vm.label,
      "item-text": "label",
      "item-value": "value",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.localValue,
      callback: function callback($$v) {
        _vm.localValue = $$v;
      },
      expression: "localValue"
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }